"use client";

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { usePostHog } from '@/hooks/usePostHog';
import { pageview } from '@/lib/ga';

export default function RouteChangeTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { track, posthog } = usePostHog();

  useEffect(() => {
    if (!pathname) return;
    const search = searchParams?.toString() || '';

    // PostHog standard pageview and custom page_viewed
    if (posthog && (posthog as any).__loaded) {
      posthog.capture('$pageview');
    }
    // GA manual page_view
    try {
      if (typeof window !== 'undefined') pageview(window.location.href)
    } catch {}
    track('page_viewed', {
      path: pathname,
      search,
      title: typeof document !== 'undefined' ? document.title : undefined,
    });
  }, [pathname, searchParams, track, posthog]);

  return null;
}
